/** Count questions across assessment steps (optionally excluding already-done LITE IDs). */
export function countQuestionsInSteps(steps, { excludeIds = [] } = {}) {
  const exclude = new Set(excludeIds || []);
  let n = 0;
  for (const step of steps || []) {
    for (const q of step.questions || []) {
      if (!q?.id) continue;
      if (exclude.size && exclude.has(q.id)) continue;
      n += 1;
    }
  }
  return n;
}

/** Remaining full-assessment questions after excluding configured/frozen LITE IDs. */
export function countRemainingFullQuestions(steps, liteQuestionIds = []) {
  return countQuestionsInSteps(steps, { excludeIds: liteQuestionIds || [] });
}

/**
 * Rough duration for intro chips.
 * LITE ~30–45s/q; full ~35–45s/q — rounded to a friendly minute estimate.
 */
export function estimateAssessmentMinutes(questionCount, { track = "lite" } = {}) {
  const n = Math.max(0, Number(questionCount) || 0);
  if (n <= 0) return track === "lite" ? 5 : 30;
  const secondsPer = track === "lite" ? 35 : 40;
  return Math.max(1, Math.round((n * secondsPer) / 60));
}

export function assessmentIntroMeta({
  track = "lite",
  questionCount,
  inviteFlow = "",
} = {}) {
  const isContinuation = inviteFlow === "v2_full_continuation";
  const label =
    track === "lite"
      ? "Lite Assessment"
      : isContinuation
        ? "Full Assessment"
        : "Full Assessment";
  const questions = Math.max(0, Number(questionCount) || 0);
  const minutes = estimateAssessmentMinutes(questions, {
    track: track === "lite" ? "lite" : "full",
  });
  return { label, questions, minutes };
}
